import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";

const Cookies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto max-w-[950px] space-y-8 px-6 py-16 text-[15px] leading-8 text-[#262626]">
        <p className="text-center text-[30px] tracking-[2px] text-btn">
          Cookie Policy
        </p>
        <p>Last Updated: 13 April 2026</p>
        <p>1. COOKIES AND TYPES OF COOKIES</p>
        <p>
          A cookie is a text-only string of information that this Site transfers
          to the cookie file of the browser on your computer's hard disk so that
          this Site can recognize you when you revisit and remember certain
          information about you. This can include which pages you have visited,
          the choices you have made from menus, any specific information you
          have entered into forms, and the time and date of your visit.
          <br />
          There are different types of cookies:
          <br />
          Strictly necessary cookies — These cookies are essential for you to
          browse the website and use its features, such as accessing secure
          areas of the site. They help us maintain security and verify your
          details whilst you use this Site as you navigate from page to page,
          which enables you to avoid having to re-enter your details each time
          you enter a new page.
          <br />
          Preferences cookies — Also known as “functionality cookies”, these
          cookies allow a website to remember choices you have made in the past,
          like preferred language and time zone.
          <br />
          Statistics cookies — Also known as “performance cookies”, these
          cookies collect information about how you use a website, like which
          pages you visited and which links you clicked on. This information is
          aggregated and anonymized. Their sole purpose is to help us understand
          how users use this Site and help us improve the structure of our Site.
          <br />
          Marketing cookies — These cookies track your online activity to help
          advertisers deliver more relevant advertising or to limit how many
          times you see an ad. These cookies can share that information with
          other organizations or advertisers.
          <br />
          In addition to the types of cookies mentioned, there are first-party
          cookies and third-party cookies, that provide respectively either us
          or third parties with information. Third-party cookies communicate
          information to third parties, such as Google Analytics. Session
          cookies are temporary cookies that expire at the end of a browser
          session that is, when you leave the site. Session cookies allow the
          Site to recognize you as you navigate between pages during a single
          browser session and allow you to use this Site most efficiently. For
          example, session cookies enable a website to remember that a user has
          placed items in an online shopping basket. Persistent cookies are
          stored on your equipment between browsing sessions until expiry or
          deletion. They enable the Site to "recognize" you on your return,
          remember your preferences, and tailor services to you.
        </p>
        <p>2. USE OF PERSONAL DATA</p>
        <p>
          Except for strictly necessary cookies, the personal data provided
          through cookies is purely voluntary. You can still use the Site
          without accepting cookies, except for the strictly necessary cookies.
          <br />
          AfterShip uses the following cookies:
          <br />
          Cookies Necessary for the Functioning of the Websites
        </p>
        <p>3. SHARING PERSONAL DATA</p>
        <p>
          We use first-party cookies (cookies that collect and send data
          directly for AfterShip to use). Regarding such cookie data, we may
          share it with any agents or consultants acting on behalf of AfterShip.
          AfterShip will implement the necessary measures to ensure compliance
          with the applicable data protection legislation. This data may be
          transferred to such recipients outside the EEA, such in the USA. In
          the case of any such transfers, we use best efforts to ensure that
          your personal data is adequately safeguarded through the
          implementation of standard data protection clauses adopted by the
          Commission. For more information on such measures, please contact
          privacy@aftership.com.
          <br />
          In addition to first-party cookies, we also use third-party cookies
          that collect information on behalf of and send it to third parties.
          These cookies are described in clause 2. Please check the relevant
          third-party website for more information about their use of cookies.
          Where this Site allows such cookies to be set or you access other
          websites from this Site using the links provided, the operators of
          these websites will use cookies in accordance with their own cookies
          policy, which may differ from ours.
        </p>
        <p>4. YOUR DATA PROTECTION RIGHTS</p>
        <p>
          4.1 Global <br />
          As a data subject you have the following rights:
          <br />
          To request access to your personal data;
          <br />
          To obtain the rectification of any inaccurate personal data;
          <br />
          To obtain the erasure of personal data.
        </p>
        <p>
          4.2 Europe <br />
          If the processing of personal information about you is subject to
          European Union data protection law, in addition to the rights
          described in clause 4.1, you have certain rights with respect to that
          information:
          <br />
          To limit the processing activities to which the personal data is
          subject (under the conditions defined in the GDPR);
          <br />
          To receive your personal data in a structured, commonly used, and
          machine-readable format, and have the personal data transmitted to
          another controller (under the conditions defined in the GDPR);
          <br />
          If processing is based on consent, to withdraw consent at any time
          (although this does not impact the lawfulness of past processing
          activities);
          <br />
          To lodge a complaint with the national supervisory authority. For more
          information, or if you wish to exercise these rights, please send your
          request to dpo@aftership.com.
        </p>
        <p>
          4.3 California <br />
          If you are a California resident and the processing of personal
          information about you is subject to the California Consumer Privacy
          Act (“CCPA”), you have certain rights with respect to that information
          in addition to the rights described in clause 4.1. In particular, you
          have a right to request that we provide you with the following
          information:
          <br />
          The categories and specific pieces of personal information we have
          collected about you;
          <br />
          The categories of sources from which we collect personal information;
          <br />
          The purposes for collecting, using, or selling personal information;
          <br />
          The categories of third parties with which we share personal
          information;
          <br />
          For companies that disclose personal information for a business
          purpose, the categories of personal information disclosed about you
          for a business purpose.
          <br />
          To make such requests, contact us at privacy@aftership.com. Please
          note that (i) we have provided the information described in 4.3.a to
          4.3.e in this privacy statement and (ii) we do not “sell” personal
          information as defined by the CCPA.
          <br />
          You also have a right to request that we delete personal information
          under certain circumstances, subject to several exceptions. Finally,
          you have a right not to be discriminated against for exercising rights
          set out in the CCPA.
        </p>
        <p>5. USING COOKIES ON THIS SITE</p>
        <p>
          You can modify, accept, or withdraw your cookie consent by sending an
          email to privacy@aftership.com. You can manage your use of cookies
          through the "Help" section on your browser. You can also disable or
          delete the stored data used by technology similar to cookies, such as
          Local Shared Objects or Flash cookies, by managing your browser's
          "add-on settings" or visiting this Site of its manufacturer.
          <br />
          Most browsers automatically accept cookies, but you can choose whether
          or not to accept cookies through your browser controls, often found in
          your browser’s “Tools” or “Preferences” menu. For more information on
          how to modify your browser settings or how to block, manage or filter
          cookies can be found in your browser’s help file or through such sites
          as: www.allaboutcookies.org. Many of the third party advertising and
          other tracking services listed above offer you the opportunity to opt
          out of their tracking systems. You can read more about the information
          they collect and how to opt out through the privacy policy links
          listed above.
          <br />
          As our cookies allow you to access some of our Site's essential
          features we recommend that you leave cookies enabled, otherwise, if
          cookies are disabled, it may mean that you experience reduced
          functionality.
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Cookies;
